import script from "./ReusableAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./ReusableAccordion.vue?vue&type=script&setup=true&lang=js"

import "./ReusableAccordion.vue?vue&type=style&index=0&id=ac2ef238&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac2ef238"]])

export default __exports__